import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as sharingActions from '@store/viewerModule/sharing/actions';
import { sharingIsFetchingSelector } from '@store/viewerModule/sharing/selectors';
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import { PAGE_TYPE } from '@utils/constants';
import sharing from '../../common/sharing';
import VMDashboard from '../index';
import injectorServer from '../../common/injectorServer';

const VMPageSelector = createSelector(
  tabsStoreSelector,
  sharingIsFetchingSelector,
  (tabsStore, isFetching) => ({
    isFetching,
    isSharing: true,
    tabs: tabsStore,
  }),
);

const VMSharingDashboard = connect(VMPageSelector, {
  init: sharingActions.initRequest,
  getSharing: sharingActions.getSharing,
  pageType: PAGE_TYPE.SHARING,
})(sharing()(VMDashboard));

export default injectorServer(
  {},
  { pageType: PAGE_TYPE.SHARING },
)(VMSharingDashboard);
